<rt-select
  [formControl]="input.control"
  [options]="$any(options)"
  [hasSearch]="input.hasSearch"
  [includeEmptyOption]="input.includeEmptyOption"
  [iconEmptyLabel]="input.iconEmptyLabel"
>
</rt-select>
